// src/services/authService.js
import axios from 'axios';

// Récupérer l'URL de base depuis les variables d'environnement
const API_URL = process.env.VUE_APP_API_URL || 'https://brickfirst.fr';
export default {
  async login(credentials) {
    try {
      const response = await axios.post(`${API_URL}/api/login`, credentials);
      const token = response.data.token;
      
      if (token) {
        localStorage.setItem('token', token);
        console.log('Token stored:', token);
        return token;
      } else {
        throw new Error("Aucun token reçu depuis l'API");
      }
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },
  
  logout() {
    console.log('Déconnexion en cours...');
    const token = localStorage.getItem('token');
    console.log('Retrieved token:', token);
    console.log("logout")
    localStorage.removeItem('token');
  },
  
  getToken() {
    return localStorage.getItem('token');
  },

  async register(userData) {
    const response = await axios.post(`${API_URL}/api/register`, userData);
    return response.data;
  },
};

// export default authService;